<template>
    <div class="auth-details fff">
        <div class="auth-management-top mb20">
            <!-- <h1 class="font-normal mb10">角色名称：{{ roleName }}</h1> -->
            <div>
                <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
                <el-divider direction="vertical" class="color999"></el-divider>
                <span class="color999 cur" @click="back">角色权限管理&nbsp;/&nbsp;</span>
                <span class="color999 cur">角色详情&nbsp;&nbsp;</span>
            </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleChanges">
            <el-tab-pane v-for="(item, index) in tab" :key="index" :label="item.title" :name="index + ''"></el-tab-pane>
        </el-tabs>
        <!-- 按钮 -->
        <div class="btn-group mr20 mb10" style="justify-content: space-between;">
            <div style="font-size: 15px;">角色名称：{{ roleName }}</div>
            <el-button type="primary" size="small" class="resetbgc" v-show="activeName == '0' && systemTag == 'no'"
                v-perm="{ key: 'rolePermManager', value: 'rolePermManager:editPerm' }" @click="update('1')">编辑</el-button>
            <el-button type="primary" size="small" class="resetbgc" v-show="activeName == '1'"
                v-perm="{ key: 'rolePermManager', value: 'rolePermManager:editUseStaff' }"
                @click="update('2')">编辑</el-button>
        </div>
        <!-- 权限详情 -->
        <div class="auth-detail" v-if="activeName == '0'">
            <div class="nav-top">
                <div class="item">模块</div>
                <div class="item">功能</div>
                <div class="item">权限</div>
            </div>
            <div class="content" style="max-height: 590px;overflow-y: auto;">
                <div class="children" v-for="item, index in menuList" :key="index"
                    style="border-bottom: 1px solid #eee;display: flex;border-right:1px solid #eee;">
                    <div
                        style="margin-right: 200px;min-width: 100px;display: flex;align-items: center;border-left: 1px solid #eee;padding: 20px 0;padding-left: 5px;">
                        {{
                            item.title }}</div>
                    <div style="border-left: 1px solid #eee;flex:1">
                        <div v-for="i, d in item.childPermList" :key="d"
                            style="display: flex;align-items: center;border-bottom: 1px solid #eee;">
                            <div
                                style="min-width: 100px;margin-right: 200px;display: flex;align-items: center;padding-left: 5px;">
                                {{
                                    i.title }}</div>
                            <div
                                style="display: flex;min-width: 400px;flex-wrap: wrap;padding: 5px 0;border-left: 1px solid #eee;">
                                <div v-for="c, z in i.resourceList" :key="z"
                                    style="margin-bottom: 10px;margin-right: 5px;padding-left: 5px;">
                                    {{ c }}<span v-if="z + 1 < i.resourceList.length">、</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeName == '1'" style="height: 650px;overflow-y: auto;">
            <el-table :data="appList" border>
                <el-table-column type="index" label="序号" width="100" />
                <el-table-column label="姓名" prop="staffName" width="auto"></el-table-column>
                <el-table-column label="手机号码" prop="mobile" width="auto"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
    data() {
        return {
            tab: [{ title: '权限详情' }, { title: '应用账号' }],
            activeName: '0',
            menuList: [],
            menuIdList: [],
            roleName: '',
            appList: [],
            systemTag: ''
        }
    },
    mixins: [minxin],
    created() {
        // this.init()
        // this.getAppList()
    },
    destroyed() {
        this.activeName = '0'
    },
    mounted() {
        this.systemTag = this.$route.query.systemTag
        this.activeName = this.$route.query.activeName
        this.init();
        this.getAppList()
    },
    methods: {
        async init() {
            this.menuList = []
            const res = await this.$api.get(this.$url.auth.getDetails, { id: this.$route.query.id })
            this.roleName = res.roleName
            res.permBOList.map(v => {
                this.menuList.push(Object.assign(v, { checkAll: false }))
            })
        },
        async getAppList() {
            this.appList = []
            const res = await this.$api.post(this.$url.auth.listUseStaffInfo, { roleId: this.$route.query.id })
            this.appList = res
        },
        handleChanges(event) {
            // this.$route.query.activeName = event.index
            this.activeName = event.index
            if (this.activeName == '0') {
                this.init()
            } else if (this.activeName == '1') {
                this.getAppList()
            }
        },
        update(option) {
            if (option == '1') {
                this.$router.push({
                    path: '/dataList/edit',
                    query: { id: this.$route.query.id, roleName: this.roleName, systemTag: this.systemTag, activeName: this.activeName, type: 'auth' }
                })
            } else {
                this.$router.push({
                    path: '/dataList/edit',
                    query: { id: this.$route.query.id, roleName: this.roleName, systemTag: this.systemTag, activeName: this.activeName, type: 'app' }
                })
            }
        },
        back() {
            this.$router.push("/dataList/authManagement");
        },

    }
}
</script>

<style scoped lang="less">
* {
    box-sizing: border-box;
}

.auth-details {
    padding: 25px;
}

.el-button.resetbgc {
    background: rgb(32, 107, 248)
}

.auth-list {
    display: flex;
    flex-wrap: wrap;
}

.nav-top {
    display: flex;
    align-items: center;
    height: 50px;
    background-color: rgb(242, 242, 242);
    padding: 0 2px;
    box-sizing: border-box;

    .item {
        min-width: 100px;
        margin-right: 200px;
        padding-left: 5px;
    }
}

.btn-group {
    display: flex;
    align-items: center;
    height: 50px;
    justify-content: flex-end;
}
</style>